// Predefined transcoding preset profiles shared between preset-select and event-job flows.

export interface PresetProfile {
  id: number;
  name: string;
  description: string;
  params: {
    video: {
      codec: string;
      profile: string;
      bitrateKbps: number;
      fps: number;
      gop: number;
      dimension: { width: number; height: number };
    };
    audio: {
      codec: string;
      bitrateKbps: number;
      sampleRate: number;
    };
  };
}

export const presetProfiles: PresetProfile[] = [
  {
    id: 647,
    name: 'Android_540P',
    description: 'Android 540P',
    params: {
      video: { codec: 'libx264', profile: 'baseline', bitrateKbps: 600, fps: 24, gop: 48, dimension: { width: 960, height: 540 } },
      audio: { codec: 'libfdk_aac', bitrateKbps: 64, sampleRate: 44100 },
    },
  },
  {
    id: 648,
    name: 'Android_720P',
    description: 'Android 720P',
    params: {
      video: { codec: 'libx264', profile: 'baseline', bitrateKbps: 1000, fps: 24, gop: 48, dimension: { width: 1280, height: 720 } },
      audio: { codec: 'libfdk_aac', bitrateKbps: 64, sampleRate: 44100 },
    },
  },
  {
    id: 649,
    name: 'iPad_1080P',
    description: 'iPad 1080P',
    params: {
      video: { codec: 'libx264', profile: 'baseline', bitrateKbps: 2000, fps: 30, gop: 60, dimension: { width: 1920, height: 1080 } },
      audio: { codec: 'libfdk_aac', bitrateKbps: 64, sampleRate: 44100 },
    },
  },
  {
    id: 650,
    name: 'iPhone_540P',
    description: 'iPhone 540P',
    params: {
      video: { codec: 'libx264', profile: 'baseline', bitrateKbps: 600, fps: 24, gop: 48, dimension: { width: 960, height: 540 } },
      audio: { codec: 'libfdk_aac', bitrateKbps: 64, sampleRate: 44100 },
    },
  },
  {
    id: 651,
    name: 'iPhone_720P',
    description: 'iPhone 720P',
    params: {
      video: { codec: 'libx264', profile: 'baseline', bitrateKbps: 1000, fps: 24, gop: 48, dimension: { width: 1280, height: 720 } },
      audio: { codec: 'libfdk_aac', bitrateKbps: 64, sampleRate: 44100 },
    },
  },
];
